import { useEffect, useState } from "react";

const START_SECONDS = 17 * 60 + 34;

export function useCountdown() {
  const [remaining, setRemaining] = useState(START_SECONDS);

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? START_SECONDS : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return {
    hours: String(hours).padStart(2, "0"),
    minutes: String(minutes).padStart(2, "0"),
    seconds: String(seconds).padStart(2, "0"),
  };
}
